import type { ComposerDestination } from './CommunityPostComposer.type';

export const destinationKey = (destination: ComposerDestination): string =>
  destination.kind === 'feed' ? 'feed' : `channel:${destination.space.id}`;
